import React, { Component } from 'react'
import { getChamp } from '../../utils/champsFunctions'
import { getCompetitorsFromChamp, getTeams, getWeightChart, updateCompetitor } from '../../utils/competitorsFunctions'

import './Weighing.css'

/* Components */
import WeighingView from './WeighingView'

class Weighing extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champ: { key: null },
            champObject: '',
            loading: true,
            arrayOfStudents: [],
            filterFaixa: '',
            filterPeso: '',
            filterIdade: '',
            filterEquipe: '',
            filteredArrayOfStudents: [],
            arrayOfTeams: [],

            studentInfoDialog: false,
            studentInfoObject: '',
            studentInfoFile: undefined,

            dataEditIsChanged: false,

            weightChartDialog: false,
            arrayOfPesos: [{ nome: 'Galo' }, { nome: 'Pluma' }, { nome: 'Pena' }, { nome: 'Leve' }, { nome: 'Médio' }, { nome: 'Meio Pesado' }, { nome: 'Pesado' }, { nome: 'Super Pesado' }, { nome: 'Pesadíssimo' }],
            quadroDePesos: [],
        }
    }

    componentWillMount = async () => {

        // Get the champ info
        let arrayOfRoute = this.props.location.pathname.split('/')
        this.setState({ champ: { __key: arrayOfRoute[3] } })
        /* Get key of champs */
        let arrayOfLocation = this.props.location.pathname.split('/')

        const champId = arrayOfLocation[3];

        const champ = await getChamp(champId);
        this.setState({
            champObject: champ
        });

        /* Get all competitors */
        this.updateListOfCompetitors(arrayOfRoute[3]);

        /* Get all teams */
        this.updateListOfTeams()

        /* get weight chart */
        const weightChart = await getWeightChart();
        this.setState({ quadroDePesos: weightChart });
    }

    /**
     * Update lists
     */
    updateListOfCompetitors = async (key) => {
        /* Get all competitors */
        let localArray = await getCompetitorsFromChamp(key);

        this.setState({
            arrayOfStudents: localArray,
            filteredArrayOfStudents: localArray,
            loading: false
        });
    }

    updateListOfTeams = async () => {
        /* Get all teams */
        let localArray = await getTeams();

        this.setState({
            arrayOfTeams: localArray
        });
    }

    /**
     * Methods to read student
     */
    searchStudent = (value) => {
        let localFilteredArray = this.state.arrayOfStudents

        /* Create array with the final result and a flag to know when another filter has alread choosed */
        let finalLocalArray = [], hasAnotherFilter = false

        /* Check if a filter of name was determined */
        if (value !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of faixa was determined */
        if (this.state.filterFaixa !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['faixa'] === this.state.filterFaixa)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['faixa'] === this.state.filterFaixa)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of peso was determined */
        if (this.state.filterPeso !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['peso'] === this.state.filterPeso)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['peso'] === this.state.filterPeso)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of idade was determined */
        if (this.state.filterIdade !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['idade'] === this.state.filterIdade)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['idade'] === this.state.filterIdade)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of equipe was determined */
        if (this.state.filterEquipe !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['equipe'] === this.state.filterEquipe)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['equipe'] === this.state.filterEquipe)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if hasn't filter was select */
        if (this.state.filterFaixa === '' && this.state.filterPeso === '' && this.state.filterIdade === '' && this.state.filterEquipe === '' && value === '') {
            finalLocalArray = localFilteredArray
        }

        this.setState({
            filteredArrayOfStudents: finalLocalArray
        })
    }

    chooseAFaixaFilter = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterFaixa: value
                })
            )
        })
            .then(() => {
                this.searchStudent(document.getElementById('searchInput').value)
            })
    }

    chooseAPesoFilter = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterPeso: value
                })
            )
        })
            .then(() => {
                this.searchStudent(document.getElementById('searchInput').value)
            })
    }

    chooseAIdadeFilter = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterIdade: value
                })
            )
        })
            .then(() => {
                this.searchStudent(document.getElementById('searchInput').value)
            })
    }

    chooseAEquipeFilter = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterEquipe: value
                })
            )
        })
            .then(() => {
                this.searchStudent(document.getElementById('searchInput').value)
            })
    }

    /**
     * Method to set weight
     */
    setAndCheckWeight = async (value, peso, idade, sexo, key) => {
        let apto = true

        /* get weight chart */
        let localQuadroDePesos = this.state.quadroDePesos

        /* Loop para identificar o sexo */
        for (let sKey in localQuadroDePesos) {
            if (sKey === sexo) {

                /* Loop para identificar a idade */
                for (let iKey in localQuadroDePesos[sKey]) {
                    if (iKey === idade) {
                        /* Loop final para identificar o peso */
                        for (let pKey in localQuadroDePesos[sKey][iKey]) {
                            if (pKey === peso) {
                                /* Check if student is fit */
                                if (value > localQuadroDePesos[sKey][iKey][pKey])
                                    apto = false
                            }
                        }
                        break
                    }
                }
                break
            }
        }

        /* Push in firebase the result of fit check */
        /* First: Push directly in table competitors */
        await updateCompetitor(this.state.champ.__key, key, { apto: apto, pesoOficial: value });

        /* Second: Update competitor in round of 16 || Método em stand by por solicitação do cliente */
        /*
        firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('competitors').doc(key).get()
        .then(specificCompetitor => {

            /* Search competitor in round of 16 *
            firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('switching').get()
            .then(switchings => {
                let j = 0
                switchings.forEach(switching => {
                    for(let i = 0; i < switching.data().roundOf16.length; i++){
                        if(switching.data().roundOf16[i].realKey === specificCompetitor.data().realKey){
                            
                            /* Update competitor in round of 16 *
                            firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('switching').doc((j+1).toString()).collection('roundOf16').doc(i.toString())
                            .update({ apto: apto, pesoOficial: value })

                            /* Send the another competitor to the next stage if the competitor is out of fit *
                            if(!apto){
                                let keyWinner = -1
                                if(i % 2 === 0)
                                    keyWinner = 1

                                firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('switching').doc((j+1).toString()).collection('roundOf16').doc(i.toString())
                                .update({ hasWon: false })

                                firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('switching').doc((j+1).toString()).collection('roundOf16').doc((i + keyWinner).toString())
                                .update({ hasWon: true })

                                /* Create a competitor with the basic infos *
                                let localCompetitor = {
                                    __key: switching.data().roundOf16[(i + keyWinner)].__key,
                                    apto: switching.data().roundOf16[(i + keyWinner)].apto,
                                    equipe: switching.data().roundOf16[(i + keyWinner)].equipe,
                                    faixa: switching.data().roundOf16[(i + keyWinner)].faixa,
                                    idade: switching.data().roundOf16[(i + keyWinner)].idade,
                                    nome: switching.data().roundOf16[(i + keyWinner)].nome,
                                    peso: switching.data().roundOf16[(i + keyWinner)].peso,
                                    pesoQtd: switching.data().roundOf16[(i + keyWinner)].pesoQtd,
                                    sexo: switching.data().roundOf16[(i + keyWinner)].sexo,
                                    wasDeleted: switching.data().roundOf16[(i + keyWinner)].wasDeleted,
                                    momentOfCreation: switching.data().roundOf16[(i + keyWinner)].momentOfCreation
                                }
                                
                                /* Push competitor in quarter finals *
                                let localIndexOfNextStage = i 
                                
                                if(i % 2 === 0){
                                    if(i === 0 || i === 8 || i === 6 || i === 14)
                                        localIndexOfNextStage = ((localIndexOfNextStage + 2) / 2) - 1
                                    else if(i === 2 || i === 10)
                                        localIndexOfNextStage = ((localIndexOfNextStage + 2) / 2)
                                    else
                                        localIndexOfNextStage = (localIndexOfNextStage / 2) - 1
                                } else {
                                    if(i === 1 || i === 7 || i === 9 || i === 15)
                                        localIndexOfNextStage = ((localIndexOfNextStage + 1) / 2) - 1
                                    else if(i === 3 || i === 11)
                                        localIndexOfNextStage = ((localIndexOfNextStage + 1) / 2)
                                    else
                                        localIndexOfNextStage = ((localIndexOfNextStage - 1) / 2) - 1
                                }
                                
                                firebase.firestore().collection('champs').doc(this.props.location.state.__key).collection('switching').doc((j+1).toString()).collection('quarterFinals').doc(localIndexOfNextStage.toString())
                                .update(localCompetitor)
                            }
                            
                        }
                    }
                    j++
                })
            })
        })
        */

        /* Update list of competitors */
        this.updateListOfCompetitors(this.state.champ.__key)

    }

    /**
     * Methods to open/close weight chart dialog
     */
    openWeightChartDialog = () => {
        this.setState({ weightChartDialog: true })
    }

    closeWeightChartDialog = () => {
        this.setState({ weightChartDialog: false })
    }

    render() {

        return (
            <WeighingView
                arrayOfTeams={this.state.arrayOfTeams}
                filteredArrayOfStudents={this.state.filteredArrayOfStudents}
                loading={this.state.loading}
                weightChartDialog={this.state.weightChartDialog}

                chooseAFaixaFilter={() => this.chooseAFaixaFilter()}
                chooseAPesoFilter={() => this.chooseAPesoFilter()}
                chooseAIdadeFilter={() => this.chooseAIdadeFilter()}
                chooseAEquipeFilter={() => this.chooseAEquipeFilter()}
                searchStudent={e => this.searchStudent(e)}
                openWeightChartDialog={() => this.openWeightChartDialog()}
                setAndCheckWeight={(v, p, i, s, k) => this.setAndCheckWeight(v, p, i, s, k)}
                closeWeightChartDialog={() => this.closeWeightChartDialog()}

                champObject={this.state.champObject}
                champKey={this.state.champ.__key}
            />
        )
    }
}

export default Weighing